// Buckets timestamped records into trailing calendar weeks, returning
// [{label, value}] ready for TrendChart — dashboards read weekly volume
// trends, not per-record noise.
export function bucketByWeek(records, dateField, weeks = 8) {
  const startOfWeek = (d) => {
    const x = new Date(d);
    x.setDate(x.getDate() - x.getDay());
    x.setHours(0, 0, 0, 0);
    return x;
  };
  const thisWeekStart = startOfWeek(new Date());
  const buckets = [];
  for (let i = weeks - 1; i >= 0; i -= 1) {
    const start = new Date(thisWeekStart);
    start.setDate(start.getDate() - i * 7);
    buckets.push({ start, count: 0 });
  }
  records.forEach((r) => {
    const raw = r[dateField];
    if (!raw) return;
    const d = new Date(raw);
    for (let i = buckets.length - 1; i >= 0; i -= 1) {
      if (d >= buckets[i].start) {
        buckets[i].count += 1;
        break;
      }
    }
  });
  return buckets.map((b) => ({
    label: b.start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }),
    value: b.count,
  }));
}
